import { Badge, ErrorMessage, Spinner } from "../../../../widgets";

import { FC } from "react";
import { FetchStatus } from "../../../../base/types";
import { IControlAttributes } from "../../../../base/models";
import { PayUButton } from "./PayUButton";
import { usePayUProperties } from "./PayUProperties";

export const DraftPayUButtonComponent: FC<IControlAttributes> = ({
    className, children, props
}) => {
    const { status, properties, error } = usePayUProperties(props);

    switch (status) {
        case FetchStatus.Idle: return <></>
        case FetchStatus.Loading: return <Spinner show={true} />
        case FetchStatus.Error: return <ErrorMessage message={error} />
    }

    if (!properties) return <></>

    return (
        <div className={"inline-block position-relative"}>
            <Badge
                className={"position-absolute top-0 end-0 text-nowrap fs-9 rounded-0"}
                badgeStyle="primary">
                PayTm
            </Badge>

            {properties && <PayUButton {...properties}
                className={className} disabled={true}>
                {children}
            </PayUButton>}
        </div>)
}
